// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

function getUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export default function ProtectedRoute({ roles, children }) {
  const token = localStorage.getItem("token");
  const user = getUser();

  if (!token || !user) return <Navigate to="/login" replace />;

  if (roles?.length && !roles.includes(user.rol)) {
    return <Navigate to="/no-permisos" replace />;
  }

  return children;
}
